<div class="table-container">
  <table class="basic-table desktop">
    <thead class="basic-table__head">
      <tr>
        @for (column of columns; track column) {
          <th [style.width]="column.width"
            [ngStyle]="{'text-align': column.textAlign}">
            {{ column.header }}
          </th>
        }
      </tr>
    </thead>
    <tbody class="basic-table__body">
      @for (item of list; track item) {
        <tr class="basic-table__body__row">
          @for (column of columns; track column) {
            <td [style.width]="column.width"
              [ngStyle]="{'text-align': column.textAlign, 'color': item['controlledMedicine'] ? '#FF8800' : 'inherit'}">
              @if (!column.isAction) {
                <ng-container [matTooltip]="item[column.field]">
                  @if (column.field == 'medicineName' || column.field === 'datetimeInclusion' || column.field === 'datetimeRelease'
                    || column.field === 'birthDate' || column.field === 'phone1' || column.field === 'dateTimeInclusion' || column.field === 'datetimeRelease'
                    || column.field === 'dateExpiration') {
                    <div [matTooltip]="item[column.field]">
                      @if (column.field === 'datetimeInclusion' || column.field === 'dateTimeInclusion' || column.field === 'datetimeRelease'
                        || column.field === 'dateExpiration') {
                        <span class="data">{{
                        item[column.field] | date:'dd/MM/yyyy \'às\' HH:mm' }}</span>
                      }
                      @if (column.field === 'birthDate') {
                        <span>
                          {{ item[column.field] | date:'dd/MM/yyyy' }}
                          {{ item.patientAge ? item.patientAge + ' anos' : '' }}
                        </span>
                      }
                      @if (column.field === 'phone1') {
                        <span>
                          {{ item[column.field] }}
                        </span>
                      }
                      @if (column.field === 'medicineName') {
                        <span class="normal">
                          <b [ngClass]="{'controlled-medicine': item.controlledMedicine}"
                          [ngStyle]="{'font-weight': '400'}">{{ item[column.field] }}</b>
                        </span>
                      }
                    </div>
                  } @else {
                    @if (item[column.field] || item[column.field] == 0) {
                      <span
                      matTooltip="{{item[column.field]}}">{{ item[column.field] }}</span>
                    }
                    @if (!item[column.field] && item[column.field] != 0) {
                      <span>-</span>
                    }
                  }
                </ng-container>
              } @else {
                <div class="actions action-icon">
                  @if (column.isViewAction) {
                    <a (click)="onViewClick(item)">
                      <mat-icon aria-hidden="false" aria-label="Visualizar">visibility</mat-icon>
                    </a>
                  }
                  @if (column.isEditAction) {
                    <a (click)="onEditClick(item)" class="action-icon">
                      <mat-icon aria-hidden="false" aria-label="Editar" [routerLink]="[]">
                        edit
                      </mat-icon>
                    </a>
                  }
                  @if (column.isGenericAction && (!column.field || item[column.field])) {
                    <button
                      (click)="onGenericClick(item, column)" class="action-icon">
                      @if (!item.isLoading) {
                        <mat-icon aria-hidden="false"
                          [attr.aria-label]="column.header">{{ column.genericIcon ||
                        'launch' }}</mat-icon>
                      }
                      @if (item.isLoading) {
                        <mat-spinner class="loading-icon" [diameter]="24"></mat-spinner>
                      }
                    </button>
                  }
                  @if (column.isGenericAction && column.field && !item[column.field]) {
                    <span>-</span>
                  }
                  @if (column.isButtomAction) {
                    <button mat-flat-button type="button" color="primary"
                      class="button-action btn-block" (click)="onButtomClick(item)">
                      @if (isLoading == false) {
                        <span>{{column.buttomName}}</span>
                      }
                      @if (isLoading == true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"
                        ></mat-spinner>
                      }
                    </button>
                  }
                </div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>